module.exports = __webpack_public_path__ + "img/asr.2d816549.png";